/** Shared styles. */

const SHARED_BACKDROP_STYLES = "flex flex-col z-50 inset-0 w-full h-full bg-gray-800/75";
const OPEN_BACKDROP_STYLES = `fixed ${SHARED_BACKDROP_STYLES}`;
const CLOSED_BACKDROP_STYLES = `hidden ${SHARED_BACKDROP_STYLES}`;

export function backdropStyles(open: boolean) {
  return open ? OPEN_BACKDROP_STYLES : CLOSED_BACKDROP_STYLES;
}
